import { Trade, OrderType } from './types';

const isSweep = (trade: Trade) => {
  return trade.orderType === OrderType.Sweep;
};

export default isSweep;
